import React, { useRef, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/avatar.png";
import Home2 from "./Home2";
import Skills from "../About/Skills";
import Experiences from "../About/Experiences";
import Type from "./Type";
import Button from "react-bootstrap/Button";
import Tilt from "react-parallax-tilt";
import Projects from "../Projects/Projects";
import Marquee from "../Marquee";

function Home() {
  const home2Ref = useRef(null);
  const skillRef = useRef(null);
  const projectRef = useRef(null);

  const scrollToHome2 = () => {
    home2Ref.current.scrollIntoView({ behavior: "smooth" });
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  return (
    <section id="#home">
      <Container fluid className="home-section" id="home">
        <div className="aurora" aria-hidden="true">
          <span className="aurora-blob blob-1"></span>
          <span className="aurora-blob blob-2"></span>
          <span className="aurora-blob blob-3"></span>
        </div>
        <Container className="home-content">
          <Row className="align-items-center">
            <Col lg={7} md={12} className="home-header" style={{ textAlign: "left" }}>
              <p className="hero-eyebrow">{"// Salutation, je suis"}</p>
              <h1
                className="heading-name"
                style={{
                  fontSize: isMobile ? "3.4em" : "6em",
                  marginBottom: "1rem"
                }}
              >
                Samuel<br />Launay
              </h1>

              {/* Hauteur réservée pour la phrase la plus longue (2 lignes sur mobile) : évite que la page saute pendant l'effet machine à écrire */}
              <h2 style={{ textAlign: "left", fontSize: isMobile ? "25px" : "30px", lineHeight: 1.2, minHeight: isMobile ? "2.4em" : "1.2em", paddingBottom: isMobile ? "50px" : "0px", boxSizing: "content-box" }}>
                <Type />
              </h2>

              <h5
                className="hero-intro"
                style={{
                    paddingRight: isMobile ? "0px" : "50px",
                    paddingTop: isMobile ? "40px" : "20px", // Plus grand sur mobile
                    fontSize: "calc(0.9rem + 0.5vw)",
                    lineHeight: "1.6"
                }}
              >
                Jeune développeur en CDI chez Teclib'.
                Passionné par le web, j'aime la liberté créative qu'il offre : chaque projet est une occasion d'exprimer mon imagination à travers le code.
              </h5>

              <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "120px",
                    marginTop: "20px"
                }}
              >
                <Button
                    onClick={scrollToHome2}
                    className="scroll-btn"
                    aria-label="Défiler vers le bas"
                >
                    <i
                        className="bi bi-chevron-down"
                        style={{
                            paddingTop: "2px",
                            fontSize: "20px",
                        }}
                    ></i>
                </Button>
              </div>
            </Col>

            <Col lg={5} md={12} className="d-flex justify-content-center" style={{ paddingBottom: 20 }}>
                <Tilt options={{ max: 25, scale: 1 }} className="d-flex justify-content-center">
                    <div className="avatar-orb">
                        <img
                            src={homeLogo}
                            alt="home pic"
                            className="img-fluid"
                            style={{
                              maxHeight: "450px",
                              maxWidth: "100%",
                              height: "auto"
                            }}
                        />
                    </div>
                </Tilt>
            </Col>
          </Row>
        </Container>
      </Container>

      <Marquee />

      <section id="about">
        <div ref={home2Ref}>
            <Home2 />
        </div>
      </section>
      <div ref={skillRef}>
        <Skills />
      </div>
      <section id="project">
        <div id="project" ref={projectRef}>
            <Projects />
        </div>
      </section>
      <section id="experiences">
      <div>
        <Experiences />
      </div>
      </section>
    </section>
  );
}

export default Home;